"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentFragment = void 0;
exports.documentFragment = `
  fragment document on NextDocument {
    id
    reference {
      ...reference
    }
    url
  }
`;
//# sourceMappingURL=document.js.map